import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";
import { L1EventsEdit } from "./edit";
import { L1EventsNew } from "./new";
import { L1EventsTable } from "./table";

export default function L1Events() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Events");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<L1EventsEdit />} />
      <Route index element={<L1EventsTable />} />
      <Route path="/new" element={<L1EventsNew />} />
    </Routes>
  );
}
